/* eslint-disable @typescript-eslint/no-unused-vars */

import { UAParser } from "ua-parser-js";

export function isMobile() {
  const userAgent = navigator.userAgent;
  const { device } = UAParser(userAgent);
  const isMobile = device.type === "mobile";

  return isMobile;
}

export function isDesktop() {
  const userAgent = navigator.userAgent;
  const { device } = UAParser(userAgent);
  const isDesktop =
    device.type === undefined || !["wearable", "mobile"].includes(device.type);

  return isDesktop;
}
